<pt-feature-info />
<pt-breadcrumbs class="bg-white" [breadcrumbs]="breadcrumbs" />
<div class="border-b border-solid border-slate-300"></div>

<div class="mx-auto max-w-[1100px] py-8">
  <nav mat-tab-nav-bar mat-stretch-tabs [tabPanel]="tabPanel">
    @for (link of navLinks; track $index) {
      <a
        #rla="routerLinkActive"
        mat-tab-link
        routerLinkActive
        [active]="rla.isActive"
        [routerLink]="link.path"
        [routerLinkActiveOptions]="{ exact: true }"
      >
        {{ link.label }}
      </a>
    }
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <router-outlet />
  </mat-tab-nav-panel>
</div>
